import 'babel-polyfill'//es6转es5兼容ie
import 'url-search-params-polyfill';//让ie支持URLSearchParams
import Vue from 'vue'
import App from './App.vue'
import router from './router';
import store from './store';
import config from './assets/js/conf/config.js';
import {request} from './assets/js/libs/request.js';
import 'swiper/dist/css/swiper.min.css'
import 'swiper/dist/js/swiper.min'
import './unit/rem.js'
// import 'jquery'
import $ from 'jquery'
Vue.directive('anchor', { // 锚链接自定义指令
    inserted: function (el, binding) {
        el.onclick = function () {
            console.log("----top",$('#anchor-' + binding.value))
            document.documentElement.scrollTop = $('#anchor-' + binding.value).context.documentElement.clientHeight
        }
    }
});
//全局变量
Vue.prototype.$config=config;
Vue.prototype.$request=request;


new Vue({
    router,
    store,
  render: h => h(App),
}).$mount('#app')
